// Default excluded categories for new blueprints (all sensitive categories 128-140)
export const DEFAULT_EXCLUDED_CATEGORIES = [128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140];
